import { useState, useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight, Star, Quote } from "lucide-react";
import { testimonials } from "../data/siteData";

const initialColors = [
  "#A85C34", "#D4A15C", "#222222", "#A85C34", "#D4A15C",
];

export default function Testimonials() {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: "start",
    slidesToScroll: 1,
  });
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    if (!emblaApi) return;
    const onSelect = () => setSelected(emblaApi.selectedScrollSnap());
    emblaApi.on("select", onSelect);
    return () => emblaApi.off("select", onSelect);
  }, [emblaApi]);

  return (
    <section className="py-20 md:py-28 lg:py-32 bg-white relative overflow-hidden" data-testid="testimonials-section">
      <div className="absolute -top-20 -left-20 w-[400px] h-[400px] rounded-full bg-[#FBF7EC] blur-3xl opacity-60 pointer-events-none" />

      <div className="frida-container relative">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 gap-6">
          <div>
            <div className="text-xs tracking-[0.25em] uppercase text-[#A85C34] font-medium mb-3">
              · Müşteri Yorumları ·
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#222222] tracking-tight leading-[1.1] max-w-2xl" data-testid="testimonials-title">
              <span className="italic text-[#A85C34]">5.0</span> Yıldız, 150+ Memnun Müşteri
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => emblaApi?.scrollPrev()}
              className="w-12 h-12 rounded-full border border-[#EAEAEA] hover:border-[#222222] flex items-center justify-center transition-colors"
              aria-label="Önceki"
              data-testid="testimonials-prev"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            <button
              onClick={() => emblaApi?.scrollNext()}
              className="w-12 h-12 rounded-full bg-[#222222] text-white hover:bg-[#A85C34] flex items-center justify-center transition-colors"
              aria-label="Sonraki"
              data-testid="testimonials-next"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="overflow-hidden" ref={emblaRef}>
          <div className="flex gap-6">
            {testimonials.map((t, i) => (
              <div
                key={i}
                className="flex-[0_0_100%] md:flex-[0_0_50%] lg:flex-[0_0_33.333%] min-w-0"
              >
                <div className="bg-[#F8F8F8] rounded-3xl p-8 lg:p-10 h-full border border-transparent hover:border-[#EAEAEA] transition-colors" data-testid={`testimonial-${i}`}>
                  <Quote className="w-8 h-8 text-[#D4A15C] mb-6" />

                  <div className="flex items-center gap-1 mb-5">
                    {[...Array(t.rating)].map((_, j) => (
                      <Star key={j} className="w-4 h-4 fill-[#D4A15C] text-[#D4A15C]" />
                    ))}
                  </div>

                  <p className="text-[#222222] text-lg leading-relaxed mb-8 font-serif italic">
                    &ldquo;{t.text}&rdquo;
                  </p>

                  <div className="flex items-center gap-4 pt-6 border-t border-[#EAEAEA]">
                    <div
                      className="w-12 h-12 rounded-full flex items-center justify-center text-white font-medium"
                      style={{ background: initialColors[i % initialColors.length] }}
                    >
                      {t.initials}
                    </div>
                    <div>
                      <div className="font-medium text-[#222222]">{t.name}</div>
                      <div className="text-xs text-[#888888] tracking-wider uppercase mt-0.5">
                        {t.role}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-10">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => emblaApi?.scrollTo(i)}
              aria-label={`Yorum ${i + 1}`}
              className={`h-1.5 rounded-full transition-all ${
                selected === i ? "w-10 bg-[#A85C34]" : "w-1.5 bg-[#EAEAEA]"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
